import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    NO: {
      translation: {
        nav_about_us: "Om Oss",
        nav_menu: "Meny",
        nav_contact_us: "Kontakt Oss",
        book_table_btn: "Bestill Bord",
        take_away_btn: "Bestill ta med",
        about_title: "Om Listen to Delhi",
        about_para1: "Hos Listen to Delhi lager vi mat med respekt for tradisjon og kjærlighet til smak. For oss handler indisk mat om mer enn krydder – det handler om omtanke, kvalitet og ekte gjestfrihet.",
        about_para2: "Vårt kjøkkenteam har røtter fra ulike deler av India og bringer sammen tradisjoner, teknikker og smaker i et felles uttrykk.",
        about_para3: "Bak restauranten står en familie med over 40 års erfaring innen catering og matservering i Delhi. Denne arven preger alt vi gjør – fra råvarer til ferdig tallerken.",
        about_para4: "Velkommen til Listen to Delhi – der tradisjon lever videre, og historien fortsetter.",        
        about_para5: "Med den samme varmen, den samme lidenskapen og med dyp respekt for det som er bygget, ønsker vi deg velkommen til Listen to Delhi — der historien fortsetter.",
        menu_label1: "Restaurant Meny",        
        menu_label2: "Smaks Meny",        
        menu_label3: "Grill Meny",        
        menu_label4: "Delhi Bites",        
        menu_label5: "Hovedmeny",        
        menu_label6: "Naan & Desserts",        
        menu_label7: "Drikke Meny",
        footer_contact: "KONTAKT OSS",
        f_open_timings: "ÅPNINGSTIDER",
        f_para1: "Indisk Restaurant i Oslo",
        f_para2: "Ring oss på",        
        f_para3: "Besøk oss på",        
        f_para4: "Mandag – Torsdag",        
        f_para5: "16.00–22.30",        
        f_para6: "Fredag–Lørdag",        
        f_para7: "15.00–23.00",        
        f_para8: "Søndag",        
        f_para9: "14.00–21.30",
        f_para10: "Kjøkkenet stenger",
        f_para11: "Mandag – Lørdag : kl. 22.00",
        f_para12: "Søndag: kl. 21:00",
        menu1_no: "/images/smaks_meny1.png",
        menu2_no: "/images/smaks_meny2.jpg",
        menu3_no: "/images/grill_meny1.png", 
        menu4_no: "/images/grill_meny2.png",
        menu5_no: "/images/delhi_bites1.png",
        menu6_no: "/images/delhi_bites2.png",
        menu7_no: "/images/hoved_meny1.png",
        menu8_no: "/images/hoved_meny2.png",
        menu9_no: "/images/naan_desserts1.png",
        menu10_no: "/images/naan_desserts2.png",

        menu11_no: "/images/smaks_meny.png",
        menu12_no: "/images/grill_meny.png",
        menu13_no: "/images/delhi_bites.png",
        menu14_no: "/images/hoved_meny.png",
        menu15_no: "/images/naan_desserts.png",
      },
    },
    EN: {
      translation: {
        nav_about_us: "About us",
        nav_menu: "Menu",
        nav_contact_us: "Contact us",
        book_table_btn: "Book Table",
        take_away_btn: "Take Away",
        about_title: "About Listen to Delhi",
        about_para1: "At Listen to Delhi, we prepare food with respect for tradition and a genuine love of flavor. To us, Indian food is about more than spices — it’s about care, quality, and true hospitality.",
        about_para2: "Our kitchen team brings roots from different parts of India, combining regional traditions, techniques, and tastes into one shared expression.",
        about_para3: "Behind the restaurant is a family with over 40 years of catering and food service experience in Delhi. That heritage shapes everything we do — from how we choose our ingredients to what arrives on your plate.",
        about_para4: "Welcome to Listen to Delhi — where tradition lives on and the story continues.",        
        about_para5: "With the same warmth, the same passion, and deep respect for what has been built, we welcome you to Listen to Delhi — where the story continues.",
        menu_label1: "Restaurant Menu",       
        menu_label2: "Tasting Menu",        
        menu_label3: "Grill Menu",        
        menu_label4: "Delhi Bites",        
        menu_label5: "Main Course",        
        menu_label6: "Naan & Desserts",        
        menu_label7: "Drinks",
        footer_contact: "CONTACT US",
        f_open_timings: "OPENING HOURS",
        f_para1: "Indian Restaurant in Oslo ",
        f_para2: "Call us on",        
        f_para3: "Visit us at ",        
        f_para4: "Monday- Thursday",        
        f_para5: "16:00-22:30",        
        f_para6: "Friday-Saturday",        
        f_para7: "16:00-23:00",        
        f_para8: "Sunday",        
        f_para9: "14:00-21:30 ",
        f_para10: "Kitchen Closes",
        f_para11: "Monday- Saturday: 22:00 ",
        f_para12: "Sunday: 21:00 ",
        menu1_no: "/images/tasting1.png",
        menu2_no: "/images/tasting2.png",
        menu3_no: "/images/grill1.png", 
        menu4_no: "/images/grill2.png",
        menu5_no: "/images/delhi1.png",
        menu6_no: "/images/delhi2.png",
        menu7_no: "/images/main1.png",
        menu8_no: "/images/main2.png",
        menu9_no: "/images/naan1.png",
        menu10_no: "/images/naan2.png",

        menu11_no: "/images/taste.png",
        menu12_no: "/images/grill.png",
        menu13_no: "/images/delhi.png",
        menu14_no: "/images/main.png",
        menu15_no: "/images/naan.png",

      },
    },
  },
  lng: localStorage.getItem("lang") ||"NO",          // default language
  fallbackLng: "NO",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
